__turbopack_context__.v({
  "styledResultsGrid": "ContentResultsSection-module__rKmY6G__styledResultsGrid",
});
